import React from 'react';
import VisualizationDisplay from './VisualizationDisplay';
import { InfoTooltip, EmptyState } from './shared/UIComponents';

function DataVisualization({ datasetName, modelType, modelId }) {
  const isMissing = !datasetName;

  return (
    <div className="data-visualization">
      <InfoTooltip 
        title="Data Visualization" 
        content="Create interactive charts and visualizations of your data and model results. Includes correlation heatmaps, cluster plots, feature importance charts, and model performance metrics."
      >
        <h2 className="data-visualization__title">Data Visualization</h2>
      </InfoTooltip>
      {isMissing ? (
        <EmptyState
          title="No dataset selected"
          description="Select a dataset to view visualizations. Model-specific charts also require a trained model."
          icon="📊"
        />
      ) : (
        <VisualizationDisplay datasetName={datasetName} modelType={modelType} modelId={modelId} />
      )}
    </div>
  );
}

export default DataVisualization;
